import React, { createContext, useContext, useState } from 'react';
import { QuestionnaireData } from '../../types';

interface QuestionnaireContextType {
  formData: Partial<QuestionnaireData>;
  updateFormData: (data: Partial<QuestionnaireData>) => void;
  validationError: string | null;
  setValidationError: (error: string | null) => void;
  isSubmitting: boolean;
  setIsSubmitting: (value: boolean) => void;
}

const QuestionnaireContext = createContext<QuestionnaireContextType | undefined>(undefined);

export function QuestionnaireProvider({ children }: { children: React.ReactNode }) {
  const [formData, setFormData] = useState<Partial<QuestionnaireData>>({});
  const [validationError, setValidationError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateFormData = (data: Partial<QuestionnaireData>) => {
    setFormData(prev => ({ ...prev, ...data }));
    setValidationError(null);
  };

  return (
    <QuestionnaireContext.Provider value={{
      formData,
      updateFormData,
      validationError,
      setValidationError,
      isSubmitting,
      setIsSubmitting
    }}>
      {children}
    </QuestionnaireContext.Provider>
  );
}

export function useQuestionnaire() {
  const context = useContext(QuestionnaireContext);
  if (!context) {
    throw new Error('useQuestionnaire must be used within QuestionnaireProvider');
  }
  return context;
}